<template>
	<v-container fluid class="ma-0 pa-0">
		<Header @currentStore="currentStoreFunc"/>
    <v-col class="pa-0" id="main_content_maxwidthset" cols="12">
			<v-col class="ma-0 pa-0 pt-5 mb-15" cols="12">
<!--        <GroupAnalyticsBox v-if="authorities.GET_STORE_GROUP"-->
<!--                           :fetchLoading="fetchLoading" />-->

				<template v-if="fetchLoading === false">
					<template v-if="currentGroup !== undefined">
						<v-col class="ma-0 pa-0 pl-5 pr-5 mb-5" cols="12"
							style="border-top:1px solid #4C4C4C;"
							v-for="(item, index) in currentGroup" :key="item.unisCustomerCd">
              <GroupStoreListItem :item="item" :authorities="authorities"
                                  :visitorDataset="visitorDatasetList[index]" :chartOptions="chartOptionsList[index]"
                                  :totalCount="totalCountList[index]" :fetchLoading="fetchLoading"
                                  :currentGroupId="currentGroupId" />
						</v-col>
					</template>
					<template v-else>
						<v-col class="ma-0 pa-10 mt-4 mb-2" cols="12" style="color:#979FB1;">
							{{t('noData')}}
						</v-col>
					</template>
				</template>
				<template v-else>
					<v-col class="ma-0 pa-0 pl-5 pr-5 mb-5" cols="12"
						style="border-top:1px solid #4C4C4C;" v-for="n in 3" :key="n">
						<v-col class="ma-0 pa-3" cols="12" style="height:4rem;"></v-col>
						<v-row class="ma-0 pa-0" align="center">
							<v-col class="ma-0 pa-0" cols="3">
								<v-skeleton-loader :boilerplate="false" elevation="0" dark 
									type="image" width="100%" height="9rem"
								></v-skeleton-loader>
							</v-col>
							<v-col class="ma-0 pa-0 pl-4" cols="9">
								<v-skeleton-loader :boilerplate="false" elevation="0" dark 
									type="image" width="100%" height="9rem"
								></v-skeleton-loader>
							</v-col>
						</v-row>
					</v-col>
				</template>
			</v-col>
		</v-col>
	</v-container>
</template>

<script>
import mixin from '@/mixin';
import Header from './Header.vue';
import $ from 'jquery';
import 'jquery-ui-dist/jquery-ui';
import * as Option from '@/components/chartOptions';
import GroupAnalyticsBox from '@/views/store-group/components/GroupAnalyticsBox.vue';
import GroupStoreListItem from '@/views/store-group/components/GroupStoreListItem.vue';
export default {
	components: {
    GroupStoreListItem,
    GroupAnalyticsBox,
		Header
	},
	mixins: [mixin.common],
	data: () => ({
    currentGroupId: '',
		currentGroup: {},
		authorities: {},
		fetchLoading: false,
    visitorDatasetList: [],
		chartOptionsList: [],
		totalCountList: [],
    storeList: [],
    deviceStatusList: ['5', '10', '12', '17', '19', '20'],
	}),
	watch: {
		'$route.query.groupId': function(item) {
			console.log(item);
			this.currentGroupId = item;
			this.fetchGroupData();
		},
	},
	created() {
		this.currentGroupId = this.$route.query.groupId;
		this.authorities = this.$store.getters.getAuthorities;
		console.log(this.$store.state.userData.storeGroupList);
	},
	mounted() {
		this.fetchGroupData();
	},
	methods: {
		tsc(t) {
      return this.$t("lang.storeSearch." + t);
    },
		tsg(t) {
      return this.$t("lang.group." + t);
    },
		fetchGroupData() {
			this.fetchLoading = true;
			const params = {};
			this.networkController.getStoresByStoreGroup(params, this.currentGroupId).then(async (res) => {
				console.log('%cGet Stores by StoreGroup\n', "color:#008DD0;", res.data);
				this.currentGroup = res.data;
				this.currentGroup.forEach((store, index) => {
					let storeCamerasList = []; // isUas가 true인 카메라 제거를 위한 빈 배열
					store.storeCameras.forEach((item) => {
            if(item.isOnline) {
						  if(item.isUas === false) {
						  	storeCamerasList.push(item);
						  }
            }
					});
          // isUas가 false인 카메라 배열을 저장
					this.currentGroup[index].storeCameras = storeCamerasList;
				});
				this.storeList = this.currentGroup;
				await this.initMakeData();
				this.fetch24hStoreAnalytics();
				this.fetch30dAnalytics();
			}).catch(error => { });
		},
    initMakeData() {
			if(this.storeList.length === 0) return;
			this.visitorDatasetList = [];
			this.chartOptionsList = [];
			this.totalCountList = [];
			for(let i = 0; i < this.storeList.length; i++) {
				this.visitorDatasetList.push({
					labels: ["07:00", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00",
					  "15:00", "16:00", "17:00", "20:00", "21:00", "22:00", "23:00", "24:00" ],
					datasets: [
						{
							backgroundColor: "#CFCF39",
							data: [],
							borderWidth: 0,
							borderColor: 'transparent',
							barThickness: 'flex',
							hoverOffset: 0
						},
						{
							backgroundColor: "#9A9A9A",
							data: [],
							borderWidth: 0,
							borderColor: 'transparent',
							barThickness: 'flex',
							hoverOffset: 0
						},
					]
				})
				this.chartOptionsList.push(Option.searchChartOption);
				this.totalCountList.push({ total: 0, known: 0 });
			}
		},
    async fetch24hStoreAnalytics() {
			let currStart = new Date();
			const from = this.getDateFormatFromHour(currStart)
			this.hourList = await this.make18HourList(currStart);
			// this.hourList = this.make18HourList(new Date('2021-05-25T07:00:00')); // 테스트용
			let curr = new Date();
			const to = this.getDateFormatToHour(curr);
			// console.log(from);
			// console.log(to);
			this.storeList.forEach((item, index, array) => {
				this.networkController.getAnalyticsVisitors({}, 'hour', from, to, item.unisCustomerCd)
				// this.networkController.getAnalyticsVisitors({}, 'hour', '202105250700', '202105252400', '490001322')
				.then(async (res) => {
					console.log(`%cunisCustomerCd = ${item.unisCustomerCd} 24h VisitorData\n`, "color:#008DD0;", res.data);
					if(res.data.length !== 0) {
						this.hourList.forEach((hour) => {
							let hourIndex = res.data.findIndex((el, idx, arr) => el.start === hour);
							if(hourIndex !== -1) {
								let analytics = res.data[hourIndex];
								this.visitorDatasetList[index].datasets[0].data.push(analytics.Data.known);
								this.visitorDatasetList[index].datasets[1].data.push(analytics.Data.unknown);
							} else {
								this.visitorDatasetList[index].datasets[0].data.push(0);
								this.visitorDatasetList[index].datasets[1].data.push(0);
							}
						})
						setTimeout(() => {
							let visitor1DataMax = Math.max(...this.visitorDatasetList[index].datasets[0].data);
							let visitor2DataMax = Math.max(...this.visitorDatasetList[index].datasets[1].data);
							let getVisitorMax = this.getMaxValue(visitor1DataMax + visitor2DataMax);
							let visitorMax = getVisitorMax;
							this.chartOptionsList[index].scales.yAxes[0].ticks.max = visitorMax;
							this.chartOptionsList[index].scales.yAxes[0].ticks.stepSize = visitorMax/2;
						}, 200);
					}
					if(index == array.length - 1) {
						setTimeout(() => {
							this.fetchLoading = false;
						}, 1000);
					}
				}).catch((err) => {
					this.fetchLoading = false;
				});
			});
		},
		fetch30dAnalytics() {
			let currStart = new Date();
			// let currStart = new Date('20210625T00:00:00'); // 테스트용
			let setStart = new Date(currStart.setDate(currStart.getDate() - 30));
			const from = this.getDateFormatFromHour(setStart);
			let curr = new Date();
			// let curr = new Date('20210625T00:00:00'); // 테스트용
			const to = this.getDateFormatToHour(curr);
			this.storeList.forEach((item, index, array) => {
				this.networkController.getAnalyticsVisitors({}, 'day', from, to, item.unisCustomerCd)
				// this.networkController.getAnalyticsVisitors({}, 'day', '20210525', '20210624', '490001322')
				.then(async (res) => {
					console.log(`%cunisCustomerCd = ${item.unisCustomerCd} 30d VisitorData\n`, "color:#008DD0;", res.data);
					if(res.data.length !== 0) {
						let total = 0;
						let known = 0;
						res.data.forEach((analytics, resIndex, array) => {
							total = total + analytics.Data.total;
							known = known + analytics.Data.known;
							if(resIndex == array.length - 1) {
								this.totalCountList[index].total = total;
								this.totalCountList[index].known = known;
							}
						});
					}
				}).catch((err) => {
					this.fetchLoading = false;
				});
			});
		},
		getDateFormatFromHour(d) {
      const year = d.getFullYear();
      const month = this.zeroPadding(d.getMonth() + 1);
      const date = this.zeroPadding(d.getDate());
      return year + month + date + '07';
		},
		getDateFormatToHour(d) {
      const year = d.getFullYear();
      const month = this.zeroPadding(d.getMonth() + 1);
      const date = this.zeroPadding(d.getDate());
      return year + month + date + '24';
		},
		zeroPadding(n) {
      return ('00' + n).slice(-2);
    },
		make18HourList(date) {
			return new Promise((resolve, reject) => {
				let result = [];
				let monthValue = date.getMonth() + 1;
				monthValue = monthValue >= 10 ? monthValue : `0${monthValue}`;
				let dayValue = date.getDate();
				dayValue = dayValue >= 10 ? dayValue : `0${dayValue}`;
				// let hourValue = date.getHours();
				// hourValue = hourValue >= 10 ? hourValue : `0${hourValue}`;
				let startDate = new Date(`${date.getFullYear()}-${monthValue}-${dayValue}T07:00:00`);
				for(let i = 0; i < 18; i++) {
					if(i == 0) {
						result.push(`${date.getFullYear()}${monthValue}${dayValue}0700`);
					} else {
						let temp = new Date(startDate.setHours(startDate.getHours() + 1));
						let year = temp.getFullYear(); // yyyy
						let month = (1 + temp.getMonth()); // M
						month = month >= 10 ? month : `0${month}`; // month 두자리로 저장
						let day = temp.getDate(); // d
						day = day >= 10 ? day : `0${day}`; // day 두자리로 저장
						let hour = temp.getHours();
						hour = hour >= 10 ? hour : `0${hour}`;
						let tempStr = `${year}${month}${day}${hour}00`;
						result.push(tempStr);
					}
				}
				return resolve(result);
			})
		},
    currentStoreFunc() {
      this.fetchGroupData();
    },
	}
}
</script>

<style lang="scss" scoped>
.v-list {
  background: #171921 !important;
	border: 1px solid #4A4A4A;
}
::v-deep {
  .v-list-item{
    color: white !important;
  }
  .v-list-item__content{
    color: white;
  }
}
</style>